import { useContext } from "react";
import {
  AlertContext,
  AlertContextProps,
} from "../context/Alert";

export default function useAlert(): AlertContextProps {
  return useContext(AlertContext);
}
